var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLedgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.87,
    height: 16.755,
    viewBox: "0 0 17.87 16.755",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7248",
    "data-name": "Group 7248",
    transform: "translate(-464.621 -889.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15652",
    "data-name": "Path 15652",
    d: "M464.621,897.657q0-3.42,0-6.84c0-.583.255-.839.835-.839,2.179,0,4.358,0,6.537,0a2.313,2.313,0,0,1,1.461.446.225.225,0,0,0,.21,0,2.27,2.27,0,0,1,1.415-.441q3.292.007,6.584,0a.718.718,0,0,1,.827.823q0,6.851,0,13.7c0,.576-.258.83-.844.83h-6.561c-.543,0-.773.208-.834.75a.7.7,0,0,1-1.393-.008.711.711,0,0,0-.818-.741h-6.584c-.58,0-.836-.257-.836-.838Q464.621,901.077,464.621,897.657Zm8.237,6.323V903.8q0-5.791,0-11.583c0-.582-.256-.839-.835-.839h-5.986v12.563h.272c1.612,0,3.225,0,4.838,0C471.709,903.942,472.272,903.966,472.857,903.98Zm8.22-.052V891.375h-5.969c-.6,0-.853.25-.853.844q0,5.78,0,11.56v.207C476.54,903.877,478.8,903.977,481.077,903.928Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15653",
    "data-name": "Path 15653",
    d: "M488.1,925.136c-.441,0-.883,0-1.324,0a.7.7,0,1,1-.01-1.4q1.336,0,2.671,0a.7.7,0,1,1,.01,1.4C488.995,925.138,488.546,925.136,488.1,925.136Z",
    transform: "translate(-18.73 -29.572)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15654",
    "data-name": "Path 15654",
    d: "M488.118,947.636c-.449,0-.9,0-1.347,0a.7.7,0,1,1-.006-1.4q1.336,0,2.671,0a.7.7,0,1,1,.006,1.4C489,947.639,488.559,947.636,488.118,947.636Z",
    transform: "translate(-18.73 -49.28)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15655",
    "data-name": "Path 15655",
    d: "M488.119,968.74c.441,0,.883,0,1.324,0a.7.7,0,1,1-.009,1.4q-1.336,0-2.671,0a.7.7,0,1,1,.009-1.4C487.221,968.739,487.67,968.74,488.119,968.74Z",
    transform: "translate(-18.73 -68.99)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15656",
    "data-name": "Path 15656",
    d: "M555.6,923.742c.441,0,.883,0,1.324,0a.7.7,0,1,1,.013,1.4q-1.336,0-2.672,0a.7.7,0,1,1,.01-1.4C554.715,923.741,555.156,923.742,555.6,923.742Z",
    transform: "translate(-77.854 -29.576)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15657",
    "data-name": "Path 15657",
    d: "M555.622,946.24c.441,0,.883,0,1.324,0a.7.7,0,1,1,.01,1.395q-1.359.006-2.718,0a.7.7,0,1,1,.013-1.395C554.708,946.237,555.165,946.24,555.622,946.24Z",
    transform: "translate(-77.854 -49.281)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15658",
    "data-name": "Path 15658",
    d: "M555.622,968.74c.441,0,.883,0,1.324,0a.7.7,0,1,1,.009,1.395q-1.359.006-2.718,0a.7.7,0,1,1,.014-1.395C554.709,968.737,555.166,968.74,555.622,968.74Z",
    transform: "translate(-77.854 -68.989)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedgerIcon);
export default __webpack_public_path__ + "static/media/ledger-icon.60e63875f31a93b9485855c37dd33f59.svg";
export { ForwardRef as ReactComponent };